/* import __COLOCATED_TEMPLATE__ from './client-form.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ContactInformationClientForm extends Component {
  @action
  onClientTypeChange(newType) {
    this.resetClientValidation();
    this.args.onClientTypeChange?.(newType);
  }

  resetClientValidation() {
    if (this.args.client) {
      this.args.client.set('_isDirty', false);
      this.resetRelatedClientValidation();
    }
  }

  resetRelatedClientValidation() {
    const relatedClient = this.args.client?.clientRelationships.at(0)?.relatedClient;
    if (relatedClient) {
      relatedClient.set('_isDirty', false);
    }
  }
}
